import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'
//CODICE VECCHIO DELONGHI

const NumberIcon = ({number, ...props}) => {
    return (
        <Box
            width={remCalc(40)}
            height={remCalc(40)}
            flexShrink={0}
            borderRadius="full"
            border="small"
            borderStyle="solid"
            borderColor="border.light"
            backgroundColor="background.default"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            lineHeight="1em"
            verticalAlign="middle"
            {...props}
        >
            <Text textStyle="body-xxlarge" fontWeight="normal" color="text.default">
                {number}
            </Text>
        </Box>
    )
}

NumberIcon.propTypes = {
    number: PropTypes.any,
}

export default NumberIcon
